export default __webpack_public_path__ + "static/aurora-01b200919d879d45b2a6a1d2cd6cf949.png";